import { render, staticRenderFns } from "./EnforceDetail.vue?vue&type=template&id=1903fe8b"
import script from "./EnforceDetail.vue?vue&type=script&lang=js"
export * from "./EnforceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports